import {updateAccessToken} from '../services/KeycloakService';
import io from 'socket.io-client';
import {getKeycloakIdToken} from '../redux/slices/KeycloakSlice';

const keycloaksocket = {
    init: async (url, state) => {
        await updateAccessToken();
        const token = state.keycloakData.keycloak.keycloakToken;//localStorage.getItem('keycloak-token');
        return io(url, {query: {token}});
    },
    connect: (socket, data, callStr, state) => {
        updateAccessToken().then(() => {
            data['token'] = state.keycloakData.keycloak.keycloakToken;//localStorage.getItem('keycloak-token');
            socket.emit(callStr, data);
        })
    },
    status: (socket, statusStr, endString, callFunction) => {
        updateAccessToken().then(() => {
            socket.on(statusStr, (arg) => {
                // console.log(arg);
                callFunction(arg);
                if (arg === endString) {
                    socket.close();
                }
            })
        })
    }
};

export default keycloaksocket;
